import { useSelector, shallowEqual } from 'react-redux';
import { ProjectId } from 'api/models';
import { Task } from 'data/tasks';
import { selectTasksByProjectId } from 'data/tasks/selectors';

export const useDocTasks = (projectId: number, documentId: number): Task[] => {
  const projectTasks = useSelector(
    selectTasksByProjectId(ProjectId(projectId)),
    shallowEqual,
  );

  return projectTasks.filter(
    (task) =>
      task.source?.sourceType === 'DOCUMENT' &&
      task.source?.sourceId === documentId,
  );
};

export const useDocSectionTasks = (projectId: number): Task[] => {
  const projectTasks = useSelector(
    selectTasksByProjectId(ProjectId(projectId)),
    shallowEqual,
  );

  return projectTasks.filter(
    (task) => task.source?.sourceType === 'DOCUMENT_SECTION',
  );
};
